exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".weedle {\n  height: 300px;\n  width: 300px;\n}\n\n@media (max-width: 600px) {\n  .weedle {\n    transform: scale(0.8);\n  }\n}\n\n@media (max-width: 300px) {\n  .weedle {\n    transform: scale(0.5);\n  }\n}\n\n.weedle > .head {\n  background: #ffcb86;\n  border-radius: 50%;\n  height: 100px;\n  width: 100px;\n}\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader?outputStyle=expanded!./source/013-weedle/Weedle.scss
 ** module id = 411
 ** module chunks = 0
 **/